import { InvoicePaymentType } from "@jugl-web/rest-api/invoices/models/common-types";

export const paymentTypeOptions: Array<{
  id: InvoicePaymentType;
  value: string;
}> = [
  {
    value: "Cash",
    id: "cash",
  },
  {
    value: "Credit",
    id: "credit",
  },
  {
    value: "Bank",
    id: "bank_transfer",
  },
];
